import { createFileRoute } from '@tanstack/react-router';

import { EditOffTheShelfPartOfferPage as PartLibraryEditOffTheShelfPartOfferPage } from '@/areas/offers/StandardPartOfferForm/pages/EditOffTheShelfPartOfferPage';
import { canEditPartLibraryOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/parts/offers/$offerId/edit')({
    staticData: { access: { permissions: canEditPartLibraryOffers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <PartLibraryEditOffTheShelfPartOfferPage {...pathParams} />;
}
